import {call, put, takeLatest} from 'redux-saga/effects'
import Logger from '../../../helpers/logger'
import {AxiosServices} from '../../../network/AxiosService';
import {ApiServices} from '../../../network/ApiServices';
import {GALLERY} from "../../constants/gallery";

function* fetchGalleryMain(actions) {
  try {
    const result = yield call(
      AxiosServices.get,
      ApiServices.GET_PAGE_BY_TYPE_DATA,
      actions.params
    )

    yield put({
      type: GALLERY.FETCH_GALLERY_PAGE.SUCCESS,
      result:  result.data
    })
  } catch(err) {
    Logger(err)
    yield put({
      type: GALLERY.FETCH_GALLERY_PAGE.FAILURE
    })
  }
}

export default function* gallerySagas() {
  yield takeLatest(GALLERY.FETCH_GALLERY_PAGE.MAIN, fetchGalleryMain);
}
